export default {
  namespaced: true,
  state: () => ({
    item: null,
    items: [],
  }),
  getters: {
    byStages(state, getters, rootState) {
      const getSort = (stageId) => {
        const projectId = rootState.project.project?.id;
        const authorSort = rootState.project.project?.authorTaskSort?.[stageId];
        const userSort = rootState.auth.user?.customSettings?.taskSort?.[projectId]?.[stageId];
        return (userSort ?? authorSort ?? []).reduce((acc, val, i) => ({ ...acc, [val]: i }), {});
      };

      const reducer = (acc, val) => {
        const stageId = val.stage.id;
        const sort = getSort(stageId);
        acc[stageId] ??= [];
        acc[stageId].push({ ...val, sort: (sort[val.id] ?? val.id) });
        return acc;
      };
      const reduced = state.items.reduce(reducer, {});

      Object.fromEntries(
        Object.entries(reduced)
          .map(([key, value]) => [
            key,
            value.sort((a, b) => a.sort - b.sort),
          ]),
      );

      return reduced;
    },
  },
  mutations: {
    set(state, payload) { state.items = payload; },
  },
  actions: { },
};
